import { makeStyles, css } from '@conexasaude/hero'

type UseStylesProps = {
  active?: boolean
}

const useStyles = makeStyles<UseStylesProps>({
  container: css`
    display: flex;
  `,
  whatsappLinkWrapper: css`
    position: fixed;
    bottom: 0;
    right: 7px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .whatsapp-link {
      margin: 16px;
      border: none;
      border-radius: 28px;
      padding: 11px 15px;
      display: flex;
      flex-direction: row;
      width: 251px;
      align-items: center;
      background: #0031b2;
      font-weight: bold;
      font-size: 1rem;
    }
    .whatsapp-link div {
      margin-left: 20px;
      color: #fff;
    }
    containerwhatsapp: {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .iconTalk {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    @media (max-width: 576px) {
      .whatsapp-link {
        width: 47px;
        height: 47px;
        padding: 0 12px;
        .whatsapp-link__text {
          display: none;
        }
      }
      .whatsapp-link div {
        margin-left: 10px;
        color: #fff;
      }
    }
  `,
})
export { useStyles }
